// extracted by mini-css-extract-plugin
export default {"wrapper":"optionsModal_wrapper__dQf6x","svg_plus":"optionsModal_svg_plus__IAMR3","inputs":"optionsModal_inputs__+cLvz","option":"optionsModal_option__ASJZn"};